import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: { titleKey: "route.home" },
          props: true,
        },
        {
          path: "/login",
          name: "login",
          component: (resolve) => require(["@/view/LoginPage"], resolve),
          meta: { titleKey: "route.login" },
        }
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      // 获取最后一个 # 后面的值
      const hash = to.hash.split("#").pop();
      return {
        selector: `#${hash}`,
        behavior: "smooth",
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js